import React from 'react';
import PropTypes from 'prop-types';
import CheckmarkIcon from 'dibs-vg/dist/react/checkmark';
import PrimaryButton from 'dibs-elements/dist/Button/Primary';
import BarHeader from 'dibs-elements/dist/BarHeader';
import ModalBody from 'dibs-elements/dist/ModalBody';
import ModalCloseButton from 'dibs-elements/dist/ModalCloseButton';
import ModalContainer from 'dibs-elements/dist/ModalContainer';
import copy from './facebookConfirmationModalCopy.json';
import style from './FacebookConfirmationModal.scss';

const FacebookConfirmationModal = ({ isOpen, onClose }) => {
    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} closeOnEsc modalPosition="center">
            <div className={style.iconContainer}>
                <CheckmarkIcon className={style.icon} />
            </div>
            <BarHeader title={copy.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <PrimaryButton onClick={onClose} className={style.button}>
                    {copy.closeCta}
                </PrimaryButton>
            </ModalBody>
        </ModalContainer>
    );
};

FacebookConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default FacebookConfirmationModal;



// WEBPACK FOOTER //
// ./assets/js/global/components/Facebook/FacebookConfirmationModal.jsx